import { Flex, Heading, Image, mediaBreakpointMixin, Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled(Flex)`
  width: 306px;
  @media ${mediaBreakpointMixin('md')} {
    width: 400px;
  }
`;

export default function ValueProp({ title, description, imgSrc, imgAlt }) {
  return (
    <StyledContainer className="ztss-value-prop" display="flex" flexDirection="column" alignItems="center">
      <Image src={imgSrc} alt={imgAlt} height={150} width={150} loading="lazy" />
      <Heading level={4} marginTop="lg" marginBottom="sm">
        {title}
      </Heading>
      <Paragraph fontColor="gray500">{description}</Paragraph>
    </StyledContainer>
  );
}

ValueProp.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  imgAlt: PropTypes.string.isRequired,
};
